import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/corporation', { params }),
  create: params => axios.post('/api/v1/avg/corporation', params),
  update: params => axios.put(`/api/v1/avg/corporation/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/corporation', { params })
};
